import { useEffect, useRef } from "react";

const FloatingHearts = ({ image }) => {
  const wrapperRef = useRef(null);
  const intervalRef = useRef(null);
  const timeoutRef = useRef(null);

  useEffect(() => {
    const wrapper = wrapperRef.current;

    if (!wrapper) return;

    const createHeart = () => {
      const heart = document.createElement("span");

      heart.classList.add("floating-heart");
      heart.innerHTML = "❤️";

      // Random horizontal position
      heart.style.left = Math.random() * 100 + "%";

      // Random size
      heart.style.fontSize = 16 + Math.random() * 16 + "px";

      // Random animation duration
      heart.style.animationDuration = 3 + Math.random() * 2 + "s";

      wrapper.appendChild(heart);

      // Remove heart after animation
      setTimeout(() => {
        heart.remove();
      }, 5000);
    };

    const startAnimation = () => {
      // Prevent duplicate intervals
      clearInterval(intervalRef.current);
      clearTimeout(timeoutRef.current);

      // Start hearts
      intervalRef.current = setInterval(createHeart, 250);

      // Stop after 3 seconds
      timeoutRef.current = setTimeout(() => {
        clearInterval(intervalRef.current);
      }, 3000);
    };

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          startAnimation();
        } else {
          clearInterval(intervalRef.current);
          clearTimeout(timeoutRef.current);
        }
      },
      {
        threshold: 0.4,
      },
    );

    observer.observe(wrapper);

    return () => {
      observer.disconnect();
      clearInterval(intervalRef.current);
      clearTimeout(timeoutRef.current);
    };
  }, []);

  return (
    <div className="quote-wrapper" ref={wrapperRef}>
      <img src={image} alt="quote-bg" className="quote-image" />
    </div>
  );
};

export default FloatingHearts;
